// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const navConfig = [
  {
    title: 'dashboard',
    path: '/dashboard/app',
    icon: icon('ic_analytics'),
  },
  {
    title: 'User Info',
    path: '/dashboard/userinfo',
    icon: icon('ic_user'),
  },
  {
    title:'Merchant',
    path:'/dashboard/merchant',
    icon: icon('ic_user'),
  }
];

export default navConfig;
